import React, { Component,Fragment } from 'react';
import { putToast, getObjects, loadObject, adminloadTP, deleteObject, updateObject, tournamentAddEvent, tournamentUpdateEvent, tournamentRemoveEvent, AuthenticatedUser, stopTimer } from "../../../api";
import TournamentPageTemplate from '../tournamentPageTemplate'
import EventTemplateCube from '../cubes/config/eventTemplateCube';
import { AvField, AvForm } from 'availity-reactstrap-validation';
const _ = require("lodash");

class TournamentConfigEvents extends Component {
    constructor(props) {
        super(props);
        const { user } = AuthenticatedUser();
        const { match: { params } } = this.props;
        this.onTemplateChange = this.onTemplateChange.bind(this);
        this.onAddToTournament = this.onAddToTournament.bind(this);
        this.onRemoveEvent = this.onRemoveEvent.bind(this);
        this.onEventDetails = this.onEventDetails.bind(this);

        this.state = {
            loading: true,
            user: user,
            tData: {},
            pid: params.pid,
            selectedEvent: null,
            selectedTemplate: ""                        
        }

    }

    loadTournamentPage = (pid) => {       
        if (this.state.pid) {
            adminloadTP('none', 'zulu', this.state.pid).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    getObjects('tEvent').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            this.setState({ pid: pid, tData: d2.tournamentPage, tUsers: d2.tUsers, tEvents: d3, loading: false});                    
                        }
                    });                    
                }
            });
        } else this.setState({ loading: false});
    };

    onTemplateDetails(selectedId) {
        loadObject('tEvent', selectedId).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ selectedEvent: d2, selectedTemplate: d2.template});
            }
        });
    }

    onEventDetails(event) {   
        this.setState({ selectedEvent: event, selectedTemplate: event.template ? event.template : ""});
    }



    onValidSubmit = (event, values) => {
        const {selectedEvent, selectedTemplate} = this.state;
        if (!selectedEvent || !selectedTemplate) return;
        const id = (selectedTemplate === selectedEvent.template) ? selectedEvent._id : null;
        const formData = new FormData(document.getElementById('mainForm'));
        
        if (selectedEvent.isCopy) {
            tournamentUpdateEvent(formData, this.state.selectedEvent._id, this.state.tData._id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    putToast.success(d2.message);    
                    _.extend(selectedEvent, values);
                    this.setState({ tData: d2.tournamentPage, selectedEvent: selectedEvent, selectedTemplated: selectedEvent.template });  
                }
            });                     
        } else {
            updateObject('tEvent', formData, id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                    putToast.error(d2 ? d2.error : "Error - no data");
                } else {
                    getObjects('tEvent').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            putToast.success(d2.message);    
                            this.setState({ selectedEvent: d2.tEvent, selectedTemplated: d2.tEvent.template, tEvents: d3  });   
                        }
                    });
                }
            });  
        }
    };
    

    onInvalidSubmit = (event, errors, values) => {
        //this.setState({errors, values});
    };
    
    onTemplateChange(ev) {
        this.setState({ selectedTemplate:  ev.target.value});   
    }

    onAddToTournament(ev) {
        ev.preventDefault();
        const formData = new FormData(document.getElementById('mainForm'));

        tournamentAddEvent(formData, this.state.tData._id).then(d2 => {
            if (d2 && d2.error) {
                console.log(d2.error);
            } else {
                this.setState({ tData:  d2.tournamentPage});   
            }
        });
    }

    onRemoveEvent(ev) {
        ev.preventDefault();

        if (this.state.selectedEvent.isCopy) {
            tournamentRemoveEvent(this.state.selectedEvent._id, this.state.tData._id).then(d2 => {
                if (d2 && d2.error) {
                    console.log(d2.error);
                } else {
                    this.setState({ tData:  d2.tournamentPage});   
                }
            });
        } else {
            deleteObject('tEvent', this.state.selectedEvent._id).then(d2 => {
                if (d2.error) {
                    console.log(d2.error);
                } else {
                    getObjects('tEvent').then(d3 => {
                        if (d3 && d3.error) {
                            console.log(d3.error);
                        } else {
                            putToast.success(d2.message);    
                            this.setState({ selectedEvent: null, selectedTemplated: "", tEvents: d3  });   
                        }
                    });                
                }
            });
        }
    }

    componentDidMount() {
        this.loadTournamentPage();
    }

    componentDidUpdate(prevProps) {
        if (this.state.selectedEvent && (this.state.selectedEvent.isCopy || 
            this.state.selectedEvent.template === this.state.selectedTemplate)) this.form && this.form.reset()                   
/*
        if(prevProps.match.params.pid !== this.props.match.params.pid) {
            this.loadTournamentPage(this.props.match.params.pid);            
        }
*/
    }

    render(){
        if (this.state.loading) { return null; }

        stopTimer();      
        const { tData, tEvents, user, selectedEvent, selectedTemplate } = this.state;

        return (
            <TournamentPageTemplate pid={this.state.pid} tData={tData} user={user} title2={`Configuration - ${user.displayname}`} title3=""
            bcTitle="Configure Events" bcParents={[{name: tData.title, url: `/tournament/config/${tData._id}`}]} 
        >                     
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-6">

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>Events</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {tData.events.map((event, index) => 
                                    <div className="row" key={index}>
                                        <div key={index} className="col-12">
                                            <span key={index} onClick={() => this.onEventDetails(event)} style={{cursor: 'pointer'}}>
                                                <EventTemplateCube key={index} tournament={tData} tEvent={event} user={user}/>
                                            </span>
                                        </div>
                                    </div>
                                )} 
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;
                            </div>
                        </div> 


                    </div>
                    <div className="col-sm-6">                         

                        <div className="card" style={{marginBottom: "10px"}}>
                            <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                <h4>Event Library</h4>
                            </div>   

                            <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                {tEvents.map((event, index) => 
                                    <button style={{margin: "4px"}} type="button" className="btn btn-warning" onClick={()=>this.onTemplateDetails(event._id)}>{event.template}</button>
                                )}                                                                         
                            </div>

                            <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                &nbsp;                                
                            </div>
                        </div> 

                        <AvForm id="mainForm" className="needs-validation" onValidSubmit={this.onValidSubmit} onInvalidSubmit={this.onInvalidSubmit} model={selectedEvent} ref={c => (this.form = c)}>
                            <div className="card" style={{marginBottom: "10px"}}>
                                <div className="card-header" style={{paddingTop: "8px", paddingBottom: "0px", borderBottom: "none"}}>
                                    <h4>Event Details
                                    {selectedEvent &&                            
                                    <>
                                    {selectedEvent.template === selectedTemplate
                                    ?    <button  className="btn btn-primary pull-right" type="submit" >Save</button>
                                    :    <button  className="btn btn-primary pull-right" type="submit" >Save As</button>
                                    }
                                    <button style={{marginRight: "8px"}} ttype="button" className="btn btn-primary pull-right" onClick={this.onAddToTournament}>Add  </button>
                                    {true && <button style={{marginRight: "8px"}} ttype="button" className="btn btn-primary pull-right" onClick={this.onRemoveEvent}>Remove  </button> }
                                    </>
                                    }
                                    </h4>     
                                </div>   
                                <div className={`card-body`} style={{paddingTop: "8px", paddingBottom: "8px"}}>
                                    {selectedEvent                         
                                    ?   <Fragment>
                                            {selectedEvent.isCopy 
                                            ?   <AvField disabled label="Template" grid={{xs: 10}} name="template" id="template" type="text" onChange={this.onTemplateChange}/>                                             
                                            :   <AvField label="Template" grid={{xs: 10}} name="template" id="template" type="text" onChange={this.onTemplateChange}/>
                                            }
                                            <AvField label="Title" grid={{xs: 10}} name="title" id="title" type="text" />
                                            <AvField label="Abbr" grid={{xs: 10}} name="abbr" id="abbr" type="text" />
                                            <hr />
                                            <AvField label="Status" grid={{xs: 10}} name="status" id="status" type="select">                                 
                                                <option disabled value="">Select Status</option>                                 
                                                <option value="open" key="open">Open</option>                                 
                                                <option value="closed" key="closed">Closed</option>                                                                                                                    
                                            </AvField>
                                            <AvField label="Fee" grid={{xs: 10}} name="fee" id="fee" type="text"/>
                                            <AvField label="Min" grid={{xs: 10}} name="min" id="min" type="text"/>
                                            <AvField label="Max" grid={{xs: 10}} name="max" id="max" type="text"/>
                                            <AvField label="SimKey" grid={{xs: 10}} name="simKey" id="simKey" type="text"/>
                                            <hr />
                                            <AvField label="Category" grid={{xs: 10}} name="category" id="category" type="select">                                 
                                                <option disabled value="">Select Category</option>                                 
                                                <option value="debate" key="debate">Debate</option>                                 
                                                <option value="interp" key="interp">Interp</option>                                                                                                                    
                                                <option value="platform" key="platform">Platform</option>                                                                                                                    
                                                <option value="limited-prep" key="limited-prep">Limited Prep</option>                                                                                                                    
                                            </AvField>                                            
                                            <AvField label="Flight Count" grid={{xs: 10}} name="flightCount" id="flightCount" type="text"/>
                                            <AvField label="Flight Duration" grid={{xs: 10}} name="flightDuration" id="flightDuration" type="text"/>
                                            <AvField label="Team Count" grid={{xs: 10}} name="teamCount" id="teamCount" type="text"/>
                                            <AvField label="Team Size" grid={{xs: 10}} name="teamSize" id="teamSize" type="text"/>
                                            <AvField label="Roles" grid={{xs: 10}} name="roles" id="roles" type="text"/>
                                            <AvField label="Resolution" grid={{xs: 10}} name="resolution" id="resolution" type="text" />                                            
                                            <hr />
                                            <AvField label="Award Order" grid={{xs: 10}} name="awardIndex" id="awardIndex" type="text"/>
                                            <AvField label="Max Award" grid={{xs: 10}} name="awardMax" id="awardMax" type="text"/>
                                            <AvField label="Max Speaker Awards" grid={{xs: 10}} name="awardMaxSpeakerPoints" id="awardMaxSpeakerPoints" type="text"/>
                                        </Fragment>  

                                    :   <p style={{backgroundColor: "#b48c50", color: "white", padding: "10px", marginTop: "25px", marginBottom: "50px"}}>No Event Selected</p>
                                    }
                                </div>
                                <div className={`card-footer`} style={{paddingTop: "8px", paddingBottom: "8px", borderTop: "none"}}>
                                    {selectedEvent &&                            
                                    <>
                                    {selectedEvent.template === selectedTemplate
                                    ?    <button  className="btn btn-primary pull-right" type="submit" >Save</button>
                                    :    <button  className="btn btn-primary pull-right" type="submit" >Save As</button>
                                    }
                                    <button style={{marginRight: "8px"}} type="button" className="btn btn-primary pull-right" onClick={this.onOpenRoundScheduleModal}>Add To Tournament</button>
                                    </>
                                    }

                                </div>
                            </div> 
                        </AvForm>
                    </div>
                </div>  
            </div>
            </TournamentPageTemplate>
            
        )
    }
}

export default TournamentConfigEvents;